import _get from 'lodash/get';
import { baseState } from '../selectors';

const getState = state => _get(baseState(state), 'login');
export const getIsSubmitting = state => _get(getState(state), 'isSubmitting');
export const getLoggedIn = state => _get(getState(state), 'loggedIn');
export const getLogInError = state => _get(getState(state), 'logInError');
export const getIsSigningOut = state => _get(getState(state), 'isSigningOut');
